import { useEffect, useRef } from 'react';

export function useLandingHashScrollRestoration(scrollToSection: (sectionId: string) => void) {
  const scrollToSectionRef = useRef(scrollToSection);
  scrollToSectionRef.current = scrollToSection;

  useEffect(() => {
    const sectionId = window.location.hash.slice(1);
    if (!sectionId) return undefined;

    const animationFrameId = window.requestAnimationFrame(() => {
      scrollToSectionRef.current(sectionId);
    });

    return () => window.cancelAnimationFrame(animationFrameId);
  }, []);
}
